export const storeName = 'user-addresses';

export default {
    LOAD_ADDRESSES: `${storeName}.LOAD_ADDRESSES`,
    LOAD_BILLING_ADDRESSES: `${storeName}.LOAD_BILLING_ADDRESSES`,
    SET_ADDRESSES: `${storeName}.SET_ADDRESSES`,
    SET_STORED_ADDRESS_ID: `${storeName}.SET_STORED_ADDRESS_ID`,
    PUT_DELIVERY_ADDRESS: `${storeName}.PUT_DELIVERY_ADDRESS`,
    PUT_BILLING_ADDRESS: `${storeName}.PUT_BILLING_ADDRESS`,
};
